/* Brain2Canvas — L-5 "Erst-Kontakt-Sequenz" fuer die Workshop-Tabs.
   Erzaehlsatz: "Es gibt drei Wege hier rein — ich zeige sie dir einmal,
   dann such dir deinen aus."

   Was es macht: Wenn die Tab-Leiste ZUM ERSTEN MAL sichtbar wird, wandert ein
   farbiger Puck EINMAL ueber die drei Tabs und rastet auf dem Default (Graffiti)
   ein. Danach loescht sich der Puck selbst und die native aria-selected-Optik
   der Section uebernimmt wieder.

   Was es bewusst NICHT macht (Motion-Entscheidung L-5, Owner-Mandat 02.08.):
   KEINE Endlos-Rotation der Panels. Die Panels sind lange Entscheidungs-Inhalte
   auf einer Buchungsflaeche — Inhalt unter dem lesenden Auge wegzutauschen ist
   die schlechteste Karussell-Anwendung, erzeugt CLS durch ungleiche Panel-Hoehen
   und braeuchte einen Pause-Button (WCAG 2.2.2). Der Puck zeigt die Wahl,
   ohne sie wegzunehmen.

   Regeln, die hier hart eingehalten werden:
   - nur transform/opacity (kein Layout, kein Paint-Property) -> CLS = 0
   - Easing + Dauer NUR aus den Motion-Tokens (colors_and_type.css)
   - Sichtbare Bewegung endet nach 440 ms (4 Stationen x 110 ms).
     Die Puck-LEBENSDAUER ist 513 ms (gemessen 161 -> 674 ms), weil nach der
     letzten Bewegung noch STEP+60 ms Aufraeumzeit laeuft, bevor sich der Puck
     entfernt. Kein Wahrnehmungsproblem — aber die ehrliche Zahl steht hier,
     nicht die geplante.
   - laeuft GENAU EINMAL, nie in Schleife
   - bricht bei JEDER Interaktion sofort ab (Hover/Focus/Tastatur/Pointer)
   - prefers-reduced-motion: passiert gar nichts, Inhalte bleiben vollstaendig
   - Scope NUR auf die Workshop-Auswahl, NICHT auf die zweite Tableiste
     ("Format-Vergleich"), sonst laufen zwei Pucks gleichzeitig.
*/
(function () {
  'use strict';

  var SCOPE = '[role="tablist"][aria-label="Workshop-Auswahl"]';
  /* STEP: die Sequenz hat VIER Stationen, nicht drei —
     Action -> Graffiti -> Tour -> zurueck auf den real vorausgewaehlten Tab.
     4 x 110 ms = 440 ms sichtbare Bewegung; Puck-Lebensdauer gemessen 513 ms (inkl. Aufraeumzeit).
     (Mit den urspruenglich geplanten 150 ms waeren es 600 ms gewesen.) */
  var STEP = 110;
  var EASE = 'cubic-bezier(.16,1,.3,1)';           // == --ease-out
  var TINT = { action: '#f6da6b', graffiti: '#9da1ca', tour: '#dcbccb' };

  /* Waehrend der Sequenz traegt der Puck die Farbe, nicht der Tab selbst —
     sonst leuchten Default-Tab und Puck gleichzeitig. Das CSS lebt HIER im
     Modul (nicht in der Section-Datei), damit M3 eigenstaendig einhaengbar
     bleibt und die L-4-Datei nicht angefasst werden muss. Nach der Sequenz
     faellt die Klasse weg -> die native aria-selected-Optik uebernimmt. */
  function injectCSS() {
    if (document.getElementById('wb-motion-css')) return;
    var s = document.createElement('style');
    s.id = 'wb-motion-css';
    // transition:none ist NICHT kosmetisch: die Section-CSS hat
    // .wb-tab{transition:.2s}. Ohne diese Zeile BLENDET die native
    // Auswahlfarbe ueber 200 ms aus, statt zu verschwinden — dann leuchten
    // am Sequenzstart zwei Pillen gleichzeitig (im Frame A-intro-000ms
    // nachgewiesen und daraufhin gefixt).
    s.textContent =
      '.wb-motion-intro .wb-tab{position:relative;z-index:1;transition:none}' +
      '.wb-motion-intro .wb-tab[aria-selected="true"]{background:transparent}';
    document.head.appendChild(s);
  }

  function run(strip) {
    var tabs = [].slice.call(strip.querySelectorAll('.wb-tab[data-k]'));
    if (tabs.length < 2) return;

    var base = tabs[0].offsetWidth;
    if (!base) return;

    var puck = document.createElement('span');
    puck.className = 'wb-motion-puck';
    puck.setAttribute('aria-hidden', 'true');
    puck.style.cssText =
      'position:absolute;top:' + tabs[0].offsetTop + 'px;left:0;' +
      'width:' + base + 'px;height:' + tabs[0].offsetHeight + 'px;' +
      'border-radius:999px;pointer-events:none;z-index:0;' +
      'transform:translate3d(' + tabs[0].offsetLeft + 'px,0,0);' +
      'transition:transform ' + STEP + 'ms ' + EASE + ',opacity ' + STEP + 'ms ' + EASE + ';' +
      'will-change:transform';
    strip.appendChild(puck);
    strip.classList.add('wb-motion-intro');

    var timers = [];
    var done = false;

    function finish() {
      if (done) return;
      done = true;
      timers.forEach(clearTimeout);
      timers.length = 0;
      strip.classList.remove('wb-motion-intro');
      if (puck.parentNode) puck.parentNode.removeChild(puck);
      strip.removeEventListener('pointerdown', finish);
      strip.removeEventListener('pointerenter', finish);
      strip.removeEventListener('focusin', finish);
      strip.removeEventListener('keydown', finish);
    }

    // WCAG 2.2.2 / Respekt vor der Absicht des Nutzers: jede Interaktion gewinnt.
    strip.addEventListener('pointerdown', finish);
    strip.addEventListener('pointerenter', finish);
    strip.addEventListener('focusin', finish);
    strip.addEventListener('keydown', finish);

    tabs.forEach(function (tab, i) {
      timers.push(setTimeout(function () {
        if (done) return;
        var w = tab.offsetWidth || base;
        puck.style.background = TINT[tab.getAttribute('data-k')] || TINT.graffiti;
        puck.style.transform =
          'translate3d(' + tab.offsetLeft + 'px,0,0) scaleX(' + (w / base) + ')';
        puck.style.transformOrigin = 'left center';
      }, i * STEP));
    });

    // Landepunkt: der real vorausgewaehlte Tab, nicht hart "Graffiti" —
    // wenn die Section ihren Default aendert, folgt die Sequenz automatisch.
    timers.push(setTimeout(function () {
      if (done) return;
      var sel = strip.querySelector('.wb-tab[aria-selected="true"]') || tabs[0];
      var w = sel.offsetWidth || base;
      puck.style.background = TINT[sel.getAttribute('data-k')] || TINT.graffiti;
      puck.style.transform =
        'translate3d(' + sel.offsetLeft + 'px,0,0) scaleX(' + (w / base) + ')';
      timers.push(setTimeout(finish, STEP + 60));
    }, tabs.length * STEP));
  }

  function boot() {
    if (matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var strip = document.querySelector(SCOPE);
    if (!strip || strip.dataset.wbMotion) return;
    strip.dataset.wbMotion = '1';
    injectCSS();
    if (getComputedStyle(strip).position === 'static') strip.style.position = 'relative';

    if (!('IntersectionObserver' in window)) { run(strip); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        io.disconnect();          // genau einmal, nie wieder
        run(strip);
      });
    }, { threshold: 0.6 });
    io.observe(strip);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
